module.exports = __webpack_public_path__ + "static/media/inherit-img1.2a4a7fbf.png";